import Choices from "choices.js";

$(document).ready(/\/curriculum-management\/examination-regulation\/\d+\/program\/(\d+\/)?(create|edit)/
    .test(window.location.pathname)&&function() {
    const updateSortIndexFunction = function(container) {
        $(container).find("input[name*=sort]").each(function(key, el) {
            $(el).val(key);
        });
    };
    const counterUpdateFunction = function() {
        let sumCreditPoints = 0;
        let sumPercentage = 0;
        const selectedElectiveModuleGroups = [];
        $(".element-row").each(function(i, elementRow) {
            let selectedElement = $(elementRow).find("select[name*=module] option:selected").first();
            if (!selectedElement) {
                return;
            }
            const isElective = !!$(selectedElement).data("elective");
            if (isElective) {
                selectedElement = $(elementRow).find("select[name*=electiveModuleGroup] option:selected").first();
                const electiveModuleGroupId = selectedElement && $(selectedElement).val();
                if (!electiveModuleGroupId || selectedElectiveModuleGroups.includes(electiveModuleGroupId) ) {
                    return;
                }
                selectedElectiveModuleGroups.push(electiveModuleGroupId);
            }
            const creditPoints = Number.parseFloat($(selectedElement).data("credit-points"));
            const percentage = Number.parseFloat($(selectedElement).data("percentage"));
            if (!isNaN(creditPoints)) {
                sumCreditPoints += creditPoints;
            }
            if (!isNaN(percentage)) {
                sumPercentage += percentage;
            }
        });
        $(".credit-point-count")
            .text(new Intl.NumberFormat('de-DE', {minimumFractionDigits: 1}).format(sumCreditPoints));
        $(".percentage-count").text(new Intl.NumberFormat('de-DE').format(sumPercentage));
    }
    const removalFunction = function() {
        const container = $(this).closest(".element-row-container");
        $(this).closest(".element-row").remove();
        updateSortIndexFunction(container);
        counterUpdateFunction();
    };
    const checkElectiveModuleGroupNecessity = function() {
        const selectedModule = $(this).find("option:selected");
        const isElectiveModuleGroupRequired = selectedModule && !!selectedModule.data("elective");
        const electiveModuleGroupSelector = $(this).closest(".element-row")
            .find(".select-elective-module-group");

        if (isElectiveModuleGroupRequired) {
            electiveModuleGroupSelector.closest(".choices").show();
        } else {
            electiveModuleGroupSelector.closest(".choices").hide();
            electiveModuleGroupSelector[0].choices.setChoiceByValue([]);
        }
    }
    const initializeElementRows = function (elementRows) {
        elementRows.find(".btn-remove-row").click(removalFunction);
        elementRows.find(".js-choice").each(function () {
            if (!this.choices) {
                this.choices = new Choices(this, window.choicesConfig(this))
            }
        });
        elementRows.find("select").change(counterUpdateFunction);
        elementRows.find("select.select-module").change(checkElectiveModuleGroupNecessity);
        elementRows.find("select.select-module").each(checkElectiveModuleGroupNecessity);
    };
    $(".btn-add-row").click(function () {
        const container = $(this).closest("div.card").find(".element-row-container");
        const currentCount = container.find(".element-row").length;
        let template = container.data('template');
        template = template.replace(/__index__/g, currentCount);
        container.append(template);
        initializeElementRows(container.find(".element-row:last"));
        container.find(".element-row:last input[name*=sort]").val(currentCount);
    });
    initializeElementRows($(".element-row-container .element-row"));
    new Sortable($(".element-row-container").get(0), {
        handle: ".draggable",
        onEnd: function(evt) {
            updateSortIndexFunction(evt.target);
        },
    });
    counterUpdateFunction();
});